import { envVariable, Variable } from "@/common/constants/envVariable";
import {
	CurrentInteractionState,
	useCurrentInteractionStore,
} from "@/common/stores/nonpersistingStores/currentInteraction";
import { SentryAppContext } from "@/components/atoms/feedback/types";
import { AgentInteractions } from "@/repository/models";
import { interactionsQueryKey } from "@/repository/queryFns/interactions";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

type SentryAppContextFeature = {
	getAppContext(): SentryAppContext;
};

export const useSentryAppContext = (): SentryAppContextFeature => {
	const queryClient = useQueryClient();

	const currentInteraction = useCurrentInteractionStore(
		(state: CurrentInteractionState) => state.active
	);

	const getAppContext = useCallback((): SentryAppContext => {
		const agentInteractions = queryClient.getQueryData<AgentInteractions>([
			interactionsQueryKey,
		]);

		const agentActiveInteractions = agentInteractions?.active?.map(
			(interaction) => ({
				id: interaction.id,
				type: interaction.type,
				queueId: interaction.queueId,
			})
		);

		return {
			activeInteractions: agentActiveInteractions,
			currentActiveInteraction: {
				id: currentInteraction?.id,
				type: currentInteraction?.type,
				queueId: currentInteraction?.queueId,
			},
			appVersion: envVariable(Variable.Version),
		};
	}, [queryClient, currentInteraction]);

	return {
		getAppContext,
	};
};
